import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Reports/ReportsSubNav';

export const ReportsLayout = () => LayoutWithSubNav({ navId });
